
import React from "react"
import { CookiesProvider } from 'react-cookie'
import { ThemeProvider } from "./src/store/theme"
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"

config.autoAddCss = false

import "./src/html.css"
import "./src/styles/help.css"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <CookiesProvider>
      {element}
    </CookiesProvider>
  </ThemeProvider>
)
